import _get from 'lodash/get';
import { updateIsWidgetExpanded } from './index';
import wix from '../services/wix';
import { ANIMATION_TIMEOUTS } from '../constants/animation-timeouts';

export const expandWidget = () => {
  return async function(dispatch) {
    await wix.resizeToExpandedMode();
    dispatch(updateIsWidgetExpanded(true));
  };
};

export const collapseWidget = () => {
  return async function(dispatch, getState) {
    dispatch(updateIsWidgetExpanded(false));
    setTimeout(() => {
      const asRounded = _get(
        getState().editorSettingsLayout,
        'collapsedAsRounded',
        false,
      );
      return wix.resizeToCollapsedMode(asRounded);
    }, ANIMATION_TIMEOUTS.COLLAPSE);
  };
};
